module.exports = __webpack_public_path__ + "assign-img-icon.png?dcaf590369adb37d58d83f3de957f285";